import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class AppleService {

  constructor(private http: HttpClient,
    @Inject('BASE_API_URL') private apiURL:string) {}

  appleLogin(data) {
    return this.http.post(this.apiURL + '/api/users/verify_apple_login', data);
  }
}
